export default {
  computed: {
    extraBinds() {
      return Object.keys(this.$attrs)
        .filter(attr => !this.propKeys.includes(attr))
        .reduce((binds, attributeName) => {
          this.$set(binds, attributeName, this.$attrs[attributeName]);
          return binds;
        }, {});
    },
    propKeys() {
      return Object.keys(this.$props);
    },
  },
};
